import React from 'react';
import { Fab, Box, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

function WhatsAppButton() {
  const phoneNumber = '12624977859'; // Número actualizado con código de país
  const message = 'Hola, me gustaría obtener más información sobre sus servicios.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '25px',
        left: '25px',
        zIndex: 1000,
        '@keyframes pulse-animation': {
          '0%': { transform: 'scale(1)', opacity: 0.7 },
          '100%': { transform: 'scale(2.5)', opacity: 0 },
        },
      }}
    >
      <Tooltip title="Contáctanos por WhatsApp" placement="right" arrow>
        <Fab 
          color="success"
          aria-label="whatsapp"
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              zIndex: -1,
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'inherit',
              borderRadius: '50%',
              animation: 'pulse-animation 2s infinite', 
            },
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
          }}
        >
          <WhatsAppIcon />
        </Fab>
      </Tooltip>
    </Box>
  );
}

export default WhatsAppButton;